module.exports = __webpack_public_path__ + "img/dash-circle-dotted.f3f96605.svg";